import { MapPin, Phone, Mail, Clock, ExternalLink } from "lucide-react";
import { COMPANY } from "../../constants/company";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { Button } from "../../components/ui/button";

export default function Office() {
  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(COMPANY.fullAddress)}`;
  return (
    <div data-testid="office-page" className="space-y-8 animate-fade-up">
      <div>
        <p className="text-xs tracking-[0.2em] uppercase text-muted-foreground font-medium">Visit us</p>
        <h1 className="text-3xl sm:text-4xl font-heading font-semibold tracking-tight mt-1">Our Office</h1>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch">
        <div className="rounded-md overflow-hidden border border-border min-h-[300px] relative">
          <img src={COMPANY.images.office} alt="Laronta Pro Tax office interior" className="absolute inset-0 w-full h-full object-cover" />
        </div>
        <div className="space-y-4">
          <Card data-testid="office-address-card">
            <CardHeader><CardTitle className="font-heading text-xl flex items-center gap-2"><MapPin className="w-5 h-5 text-primary" /> Address</CardTitle></CardHeader>
            <CardContent className="text-sm space-y-1">
              <p className="font-medium">{COMPANY.name}</p>
              <p className="text-muted-foreground">{COMPANY.address}</p>
              <p className="text-muted-foreground">{COMPANY.city}, {COMPANY.state} {COMPANY.zip}</p>
              <Button asChild variant="outline" size="sm" className="mt-3">
                <a href={mapsUrl} target="_blank" rel="noreferrer" data-testid="office-directions-link">
                  Get Directions <ExternalLink className="w-3.5 h-3.5 ml-1" />
                </a>
              </Button>
            </CardContent>
          </Card>
          <Card data-testid="office-contact-card">
            <CardHeader><CardTitle className="font-heading text-xl flex items-center gap-2"><Phone className="w-5 h-5 text-primary" /> Contact</CardTitle></CardHeader>
            <CardContent className="text-sm space-y-2">
              <a href={COMPANY.phoneHref} data-testid="office-tab-phone-link" className="block hover:text-primary transition-colors">{COMPANY.phone}</a>
              <a href={COMPANY.emailHref} data-testid="office-tab-email-link" className="flex items-center gap-1.5 hover:text-primary transition-colors">
                <Mail className="w-3.5 h-3.5" /> {COMPANY.email}
              </a>
            </CardContent>
          </Card>
          <Card data-testid="office-hours-card">
            <CardHeader><CardTitle className="font-heading text-xl flex items-center gap-2"><Clock className="w-5 h-5 text-primary" /> Hours</CardTitle></CardHeader>
            <CardContent className="text-sm space-y-1">
              {COMPANY.hours.map((h) => (
                <div key={h.days} className="flex justify-between border-b border-border last:border-0 pb-2 last:pb-0">
                  <span className="text-muted-foreground">{h.days}</span>
                  <span className="font-medium">{h.time}</span>
                </div>
              ))}
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
